import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ChatStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M19 4.91C17.13 3.03 14.64 2 11.99 2C6.53 2 2.08 6.45 2.08 11.91C2.08 13.66 2.54 15.36 3.4 16.86L2 22L7.25 20.62C8.7 21.41 10.33 21.83 11.99 21.83C17.45 21.83 21.9 17.38 21.9 11.92C21.9 9.27 20.87 6.78 19 4.91ZM11.99 20.15C10.51 20.15 9.06 19.75 7.79 19L7.49 18.82L4.37 19.64L5.2 16.6L5 16.29C4.18 14.98 3.74 13.46 3.74 11.91C3.74 7.37 7.44 3.67 11.98 3.67C14.18 3.67 16.25 4.53 17.8 6.09C19.36 7.65 20.21 9.72 20.21 11.92C20.23 16.46 16.53 20.15 11.99 20.15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ChatStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ChatStrokeIcon;
